<div class="pov-page" *ngIf="!loading && po; else loadingTpl">

  <!-- Title row -->
  <div class="pov-title-row">
    <h1 class="pov-title-row__name">{{ po.name }}</h1>
    <span class="pov-status pov-status--{{ statusCode }}" *ngIf="po.stage">{{ po.stage }}</span>
    <div class="pov-title-row__actions">
      <button *ngIf="canEdit" class="pov-icon-btn pov-icon-btn--circle" title="Edit" aria-label="Edit purchase order" (click)="editOrder()">
        <svg width="20" height="20" viewBox="0 0 18.3266 18.1481" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M6.3764 17.0279L15.1628 5.66544C15.6403 5.0527 15.8101 4.3443 15.6509 3.62299C15.513 2.96726 15.1097 2.34377 14.5049 1.87078L13.0299 0.699064C11.7459 -0.322161 10.1541 -0.214663 9.24152 0.957057L8.25465 2.23735C8.12731 2.39752 8.15914 2.63401 8.31832 2.76301C8.31832 2.76301 10.812 4.76246 10.8651 4.80546C11.0349 4.96671 11.1622 5.1817 11.1941 5.43969C11.2471 5.94493 10.8969 6.41792 10.377 6.48242C10.1329 6.51467 9.89944 6.43942 9.72966 6.29967L7.1086 4.21422C6.98126 4.11855 6.79025 4.13898 6.68413 4.26797L0.455138 12.3303C0.0518985 12.8355 -0.086052 13.4912 0.0518984 14.1255L0.847767 17.5761C0.890213 17.7589 1.04939 17.8879 1.24039 17.8879L4.74222 17.8449C5.37891 17.8341 5.97316 17.5439 6.3764 17.0279Z" fill="currentColor"/>
          <path d="M10.6996 15.6481C10.0092 15.6481 9.44958 16.2078 9.44958 16.8981C9.44958 17.5885 10.0092 18.1481 10.6996 18.1481H17.0766C17.7669 18.1481 18.3266 17.5885 18.3266 16.8981C18.3266 16.2078 17.7669 15.6481 17.0766 15.6481H10.6996Z" fill="currentColor"/>
        </svg>
      </button>
      <button *ngIf="canCancel" class="pov-icon-btn pov-icon-btn--circle pov-icon-btn--danger" title="Cancel PO" aria-label="Cancel purchase order" (click)="closeOrder()">
        <svg width="20" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M15.9395 6.69727C16.1385 6.69738 16.3191 6.78402 16.4619 6.93066C16.5952 7.08766 16.663 7.28326 16.6436 7.48926C16.6429 7.56521 16.1099 14.2984 15.8057 17.1338C15.6151 18.8747 14.493 19.9319 12.8096 19.9609C11.5151 19.9899 10.2497 20 9.00391 20C7.68123 20 6.3874 19.9899 5.13184 19.9609C3.50488 19.9218 2.38206 18.8457 2.20117 17.1338C1.88816 14.2881 1.36472 7.56385 1.35449 7.48926C1.34477 7.28326 1.41071 7.08766 1.54492 6.93066C1.67715 6.78375 1.86811 6.69731 2.06836 6.69727H15.9395ZM11.0645 0C11.9485 0 12.7382 0.617079 12.9668 1.49707L13.1309 2.22656C13.2631 2.82145 13.778 3.24302 14.3711 3.24316H17.2871C17.676 3.24316 17.9998 3.56576 18 3.97656V4.35742C17.9997 4.75821 17.676 5.09082 17.2871 5.09082H0.713867C0.324025 5.09082 0.000250461 4.75821 0 4.35742V3.97656C0.000208833 3.56576 0.323999 3.24316 0.713867 3.24316H3.62988C4.22203 3.24301 4.7369 2.82143 4.87012 2.22754L5.02344 1.5459C5.26078 0.61698 6.04181 0 6.93555 0H11.0645Z" fill="currentColor"/>
        </svg>
      </button>
      <button *ngIf="canClose" class="pov-icon-btn pov-icon-btn--circle" title="Close PO" aria-label="Close purchase order" (click)="lockOrder()">
        <svg width="20" height="20" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M7.98828 3.9243e-05C9.40247 -0.00539086 10.7615 0.552906 11.7637 1.55082C12.766 2.54916 13.3291 3.90564 13.3291 5.32035V7.57523C14.9172 8.41289 16 10.0798 16 12V14C16 16.7615 13.7614 19 11 19H5C2.23858 19 0 16.7615 0 14V12C0 10.0798 1.08282 8.41289 2.6709 7.57523V5.32035C2.67095 2.38287 5.0511 0.00138707 7.98828 3.9243e-05ZM8 11C7.44772 11 7 11.4478 7 12V14C7 14.5523 7.44772 15 8 15C8.55228 15 9 14.5523 9 14V12C9 11.4478 8.55228 11 8 11ZM7.99121 2.00004C6.15745 2.00004 4.67095 3.48661 4.6709 5.32035V7.01176C4.77971 7.00469 4.8894 7.00004 5 7.00004H11C11.1106 7.00004 11.2203 7.00469 11.3291 7.01176V5.32035C11.3291 4.43732 10.9773 3.59089 10.3516 2.96781C9.72586 2.3448 8.87809 1.99633 7.99512 2.00004H7.99121Z" fill="currentColor"/>
        </svg>
      </button>
      <button *ngIf="canReopen" class="pov-icon-btn pov-icon-btn--circle" title="Reopen PO (Back to approved)" aria-label="Reopen purchase order" (click)="unlockOrder()">
        <svg width="20" height="20" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M8.31836 3.89667e-05C9.73252 -0.00537189 11.0906 0.552923 12.0928 1.55082C12.4839 1.94053 12.4853 2.5736 12.0957 2.96488C11.706 3.356 11.0729 3.35732 10.6816 2.96781C10.0559 2.34472 9.20727 1.9963 8.32422 2.00004H8.32031C6.4866 2.00009 5.00005 3.48664 5 5.32035V7.00004L11.5127 7.00004C13.9061 7.00004 16 8.797 16 11.1944L16 14.8057C16 17.2031 13.9061 19 11.5127 19H4.4873C2.09388 19 2.24847e-05 17.2031 0 14.8057L0 11.1944C1.7423e-05 9.31351 1.28884 7.80223 3 7.23832L3 5.32035C3.00005 2.38274 5.38101 0.0011836 8.31836 3.89667e-05ZM8 10.7998C7.44772 10.7998 7 11.2476 7 11.7998V14.2998C7 14.8521 7.44772 15.2998 8 15.2998C8.55228 15.2998 9 14.8521 9 14.2998V11.7998C9 11.2476 8.55228 10.7998 8 10.7998Z" fill="currentColor"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Status informational banner -->
  <div
    class="pov-status-banner"
    *ngIf="statusBanner"
    [style.background]="statusBanner.bg"
  >
    <svg class="pov-status-banner__icon" width="24" height="24" viewBox="0 0 21 21" fill="none" [style.color]="statusBanner.iconColor" aria-hidden="true">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 2.5C6.08236 2.5 2.5 6.08236 2.5 10.5C2.5 14.9176 6.08236 18.5 10.5 18.5C14.9186 18.5 18.5 14.9177 18.5 10.5C18.5 6.08227 14.9186 2.5 10.5 2.5ZM0 10.5C0 4.70164 4.70164 0 10.5 0C16.2994 0 21 4.70173 21 10.5C21 16.2983 16.2994 21 10.5 21C4.70164 21 0 16.2984 0 10.5ZM10.4951 5.4541C11.1854 5.4541 11.7451 6.01375 11.7451 6.7041V11.1231C11.7451 11.8135 11.1854 12.3731 10.4951 12.3731C9.80473 12.3731 9.24509 11.8135 9.24509 11.1231V6.7041C9.24509 6.01375 9.80473 5.4541 10.4951 5.4541ZM10.4951 13.0459C9.80474 13.0459 9.24509 13.6055 9.24509 14.2959C9.24509 14.9863 9.80474 15.5459 10.4951 15.5459H10.5051C11.1954 15.5459 11.7551 14.9863 11.7551 14.2959C11.7551 13.6055 11.1954 13.0459 10.5051 13.0459H10.4951Z" fill="currentColor"/>
    </svg>
    <p class="pov-status-banner__text">{{ statusBanner.message }}</p>
  </div>

  <!-- Main two-column layout -->
  <div class="pov-layout">

    <!-- Left: info cards -->
    <div class="pov-main">

      <!-- General information -->
      <section class="pov-card">
        <h2 class="pov-card__title">General information</h2>
        <div class="pov-grid">
          <div class="pov-field">
            <span class="pov-label">PO ID</span>
            <span class="pov-value">{{ po.po_id || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Purchase Order name</span>
            <span class="pov-value">{{ po.name || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Source type</span>
            <span class="pov-value">{{ sourceTypeName || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Maker to execute</span>
            <span class="pov-value">{{ po.maker_name || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field" *ngIf="poTypeName">
            <span class="pov-label">PO Type</span>
            <span class="pov-value">{{ poTypeName || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Rappi owner</span>
            <span class="pov-value">{{ po.owner_id || EMPTY_VALUE }}</span>
          </div>
        </div>
      </section>

      <!-- Purchase order document -->
      <app-section-po-document
        [form]="docForm"
        [mode]="DOC_MODE"
        [sourceType]="DOC_SOURCE_TYPE"
        [poLoaded]="true"
        [viewMode]="true"
      ></app-section-po-document>

            <!-- Budget & Dates -->
      <section class="pov-card">
        <h2 class="pov-card__title">Budget &amp; Dates</h2>
        <div class="pov-grid">
          <ng-container *ngIf="sourceTypeCode === SOURCE_TYPE.TRATO || sourceTypeCode === SOURCE_TYPE.CLIENT">
            <div class="pov-field">
              <span class="pov-label">PO External ID</span>
              <span class="pov-value">{{ po.external_id || EMPTY_VALUE }}</span>
            </div>
            <div class="pov-field"></div>
          </ng-container>
          <div class="pov-field">
            <span class="pov-label">PO Budget</span>
            <span class="pov-value pov-value--budget">
              {{ po.budget != null ? formatCurrency(po.budget, po.currency) : EMPTY_VALUE }}
            </span>
          </div>
          <div class="pov-field">
            <span class="pov-label">PO Currency</span>
            <span class="pov-value">{{ po.currency || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field" *ngIf="sourceTypeCode === SOURCE_TYPE.CLIENT || sourceTypeCode === SOURCE_TYPE.TRATO">
            <span class="pov-label">Co-investment %</span>
            <span class="pov-value">{{ po.co_investment_percentage != null ? po.co_investment_percentage + '%' : EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field" *ngIf="sourceTypeCode === SOURCE_TYPE.CLIENT || sourceTypeCode === SOURCE_TYPE.TRATO">
            <span class="pov-label">Re-investment %</span>
            <span class="pov-value">{{ po.re_investment_percentage != null ? po.re_investment_percentage + '%' : EMPTY_VALUE }}</span>
          </div>
        </div>
      </section>

      <!-- Buyer information -->
      <section class="pov-card" *ngIf="companyToBillName || contactName || agencyName || revenueRecognitionMethodLabel">
        <h2 class="pov-card__title">Buyer information</h2>
        <div class="pov-grid">
          <div class="pov-field" *ngIf="companyToBillName">
            <span class="pov-label">Company to bill</span>
            <span class="pov-value">{{ companyToBillName }}</span>
          </div>
          <div class="pov-field" *ngIf="contactName">
            <span class="pov-label">Point of contact</span>
            <span class="pov-value">{{ contactName }}</span>
          </div>
          <div class="pov-field" *ngIf="agencyName">
            <span class="pov-label">Agency</span>
            <span class="pov-value">{{ agencyName }}</span>
          </div>
          <div class="pov-field" *ngIf="revenueRecognitionMethodLabel">
            <span class="pov-label">Revenue Recognition Method</span>
            <span class="pov-value">{{ revenueRecognitionMethodLabel }}</span>
          </div>
        </div>
      </section>

      <!-- Additional Info -->
      <section class="pov-card">
        <h2 class="pov-card__title">Additional Info</h2>
        <div class="pov-grid">
          <div class="pov-field">
            <span class="pov-label">Tags</span>
            <div class="pov-tags" *ngIf="po.tags.length > 0; else noTags">
              <span class="pov-tag" *ngFor="let tag of po.tags">{{ tag.name }}</span>
            </div>
            <ng-template #noTags><span class="pov-value">{{ EMPTY_VALUE }}</span></ng-template>
          </div>
          <div class="pov-field" *ngIf="po.request_reason">
            <span class="pov-label">Request reason</span>
            <span class="pov-value">{{ requestReasonLabel }}</span>
          </div>
          <div class="pov-field pov-field--full">
            <span class="pov-label">Details</span>
            <span class="pov-value">{{ po.additional_info || EMPTY_VALUE }}</span>
          </div>
        </div>
      </section>

      <!-- Audit -->
      <section class="pov-card">
        <h2 class="pov-card__title">Audit</h2>
        <div class="pov-grid">
          <div class="pov-field">
            <span class="pov-label">Creado por</span>
            <span class="pov-value">{{ po.created_by || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Modificado por</span>
            <span class="pov-value">{{ po.updated_by || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Approved at</span>
            <span class="pov-value">{{ po.approved_at ? formatDate(po.approved_at) : EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Approved by</span>
            <span class="pov-value">{{ po.approved_by || EMPTY_VALUE }}</span>
          </div>
          <div class="pov-field">
            <span class="pov-label">Close at</span>
            <span class="pov-value">{{ po.closed_at ? formatDate(po.closed_at) : EMPTY_VALUE }}</span>
          </div>
        </div>
      </section>

    </div>

    <!-- Right: approval + comments -->
    <aside class="pov-sidebar">

      <!-- Approval -->
      <app-po-approval-actions
        [statusCode]="statusCode"
        [sourceTypeCode]="sourceTypeCode"
        (resubmitForApproval)="resubmitForApproval()"
        (retrySettlement)="retrySettlement()"
        (retryTrato)="retryTrato()"
        (approvePurchaseOrder)="approvePurchaseOrder()"
        (returnToKam)="returnToKam()"
      ></app-po-approval-actions>

      <!-- Comments -->
      <section class="pov-card pov-card--comments">
        <div class="pov-card__title-row">
          <h2 class="pov-card__title">Comments</h2>
        </div>

        <!-- New comment input -->
        <div class="pov-comment-input" *ngIf="canComment">
          <textarea
            class="pov-comment-input__field"
            placeholder="Add comment"
            [(ngModel)]="newComment"
            (keydown.enter)="addComment()"
            aria-label="Add a comment"
            rows="5"
          ></textarea>
          <div class="pov-comment-input__actions">
            <button type="button" class="pov-comment-input__btn" aria-label="Attach file" (click)="attachFile()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <button type="button" class="pov-comment-input__btn pov-comment-input__btn--send" aria-label="Send comment" (click)="addComment()">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        <!-- Comment list -->
        <div class="pov-comments" *ngIf="comments.length > 0">
          <div class="pov-comment" *ngFor="let comment of comments">
            <div
              class="pov-comment__avatar"
              [style.background]="getInitialsColor(comment.initials)"
            >
              {{ comment.initials }}
            </div>
            <div class="pov-comment__bubble">
              <div class="pov-comment__header">
                <span class="pov-comment__author">{{ comment.author }}</span>
                <span class="pov-comment__date">{{ comment.date }}</span>
              </div>
              <p class="pov-comment__text">{{ comment.text }}</p>
            </div>
          </div>
        </div>

        <p class="pov-comments--empty" *ngIf="comments.length === 0">No comments yet</p>
      </section>

    </aside>
  </div>
</div>

<ng-template #loadingTpl>
  <div class="pov-loading">Loading purchase order…</div>
</ng-template>
